import React from 'react';
import { StripeProvider, Elements } from 'react-stripe-elements';
import StripeScriptLoader from 'react-stripe-script-loader';
import StripeForm from './StripeForm';
import PropTypes from "prop-types";

const Stripe = React.memo(({ closeStripeModal, openStripeModal, stripeTokenHandler, modalLoading, setModalLoading }) => {
  return (
    <StripeScriptLoader
      uniqueId='myUniqueId'
      script='https://js.stripe.com/v3/'
      loader=""
    >
      <StripeProvider apiKey="pk_live_51HAhfIA8I7TAzuCxx3FaIck4mREXDLcYwbaYhJ6edUIuDW2CLfZIeocwipdbBK7FwsiurntFReKIAa2tXYTDhomN00sLlE2ssv">
        <Elements>
          <StripeForm
            open={openStripeModal}
            closeModal={closeStripeModal}
            stripeTokenHandler={stripeTokenHandler}
            modalLoading={modalLoading}
            setModalLoading={setModalLoading}
          />
        </Elements>
      </StripeProvider>
    </StripeScriptLoader>
  );
});

Stripe.propTypes = {
  openStripeModal: PropTypes.bool.isRequired,
  closeStripeModal: PropTypes.func.isRequired,
  stripeTokenHandler: PropTypes.func.isRequired,
  modalLoading: PropTypes.bool.isRequired,
  setModalLoading: PropTypes.func.isRequired,
};

export default Stripe;
